import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import LoadingSpinner from '../login/loading';
import axios from 'axios';
import { format, parseISO } from 'date-fns'; // Importer date-fns pour le formatage
import { fr } from 'date-fns/locale'; //Importer la locale française
import moment from 'moment';
import RedirectionComplement from './redirectioncomplement';
import { getAuthToken } from '../../authToken';

const Navbar = () => {
  // RedirectionComplement()
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // État pour gérer le chargement pendant la déconnexion
  const [notifications, setNotifications] = useState([]); // État pour gérer les notifications
  const [accesGroupe, setAccesGroupe] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const groupe = localStorage.getItem('groupe');
  // État pour stocker l'ID du formulaire
  const [formulaire_id, setFormulaireId] = useState(null);
  const [groupeId, setGroupeId] = useState(null); // State pour stocker l'ID du groupe
  const [isGroupeVerified, setIsGroupeVerified] = useState(false); // State pour savoir si la vérification est faite

  const user_id = localStorage.getItem('user_id');

  useEffect(() => {
    console.clear(); // Vide la console au montage du composant
  }, []);

  // Fonction pour récupérer les informations de l'utilisateur
  const fetchUserData = useCallback(async () => {
    try {
                const token = localStorage.getItem('access_token');
    
                const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                    method: 'get',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });

      if (response.ok) {
        const data = await response.json();
        setUser(data);
      }
    } catch (error) {
      // console.error('Erreur lors de la récupération des données utilisateur:', error);
    }
  }, [user_id]);

  // Utilisation de `user` avec des vérifications
  const name = user?.nom ?? ''; // Utilisation d'une valeur par défaut si user est null
  const surname = user?.prenoms ?? ''; // Utilisation d'une valeur par défaut si user est null

  if (name && surname) {
    const Username = `${name} ${surname}`;
    localStorage.setItem('Username', Username);
  }

  const Username = localStorage.getItem('Username') || 'Utilisateur'; // Valeur par défaut

  const verifGroupe = useCallback(async () => {
    if (isGroupeVerified || groupeId) return; // Empêche la vérification multiple
  
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
      if (response.status === 200) {
        const data = response.data;
        setGroupeId(data.groupe);
  
        let cleanedAccessArray = [];
  
        // Vérifie si `data.acces` est un tableau contenant plusieurs éléments
        if (Array.isArray(data.acces) && data.acces.length > 1) {
          // Cas avec plusieurs objets `acces`
          cleanedAccessArray = data.acces.map((item) => {
            if (item.acces) {
              // Nettoyer et diviser chaque chaîne d’accès en tableau
              return item.acces.replace(/[\[\]']/g, '').split(',').map((access) => access.trim());
            }
            return []; // Si `acces` est vide, retourne un tableau vide
          }).flat(); // Aplatir pour un tableau plat de tous les accès
        } else if (data.acces.length === 1 && typeof data.acces[0].acces === 'string') {
          // Cas où `data.acces` contient un seul objet `acces` sous forme de chaîne
          cleanedAccessArray = data.acces[0].acces.replace(/[\[\]']/g, '').split(',').map((access) => access.trim());
        }
  
        // Stocke les accès nettoyés
        setAccesGroupe(cleanedAccessArray);
  
        // Stockage pour éviter la requête multiple
        localStorage.setItem('groupe', data.groupe);
        localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray)); // Stocker accesGroupe comme string JSON
  
        setIsGroupeVerified(true); // Marque la vérification comme faite
      }
    } catch (error) {
      // if (error.response) {
      //   if (error.response.status === 404) {
      //     console.warn("Le groupe ou l'utilisateur n'existe pas.");
      //   } else {
      //     console.error('Erreur lors de la vérification du groupe - Code:', error.response.status);
      //   }
      // } else if (error.request) {
      //   console.error('Aucune réponse du serveur lors de la vérification du groupe', error.request);
      // } else {
      //   console.error('Erreur lors de la configuration de la requête', error.message);
      // }
    }
  },[user_id, groupe, groupeId, isGroupeVerified]);
  
  
  const fetchFormulaireId = useCallback(async () => {
    try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-utilisateur/${user_id}/`);
        if (!response.ok) throw new Error('Erreur réseau');
        const data = await response.json();

        // Récupérer l'ID du formulaire à partir des données
        if (data.id) {
            setFormulaireId(data.id);
        }
    } catch (error) {
        // console.error("L'utilisateur n'a probablement pas de formulaire enregistré:", error);
    }
},[user_id]);



// const fetchNotifications = useCallback(async () => {
//   try {
//     let data = [];

//     if (accesGroupe.includes('Administration')) {
//       // Notifications ADMIN uniquement pour les vrais administrateurs
//       const responseA = await fetch(process.env.REACT_APP_HOTE + `/liste-notifications-admin/`);
//       if (responseA.ok) {
//         const dataA = await responseA.json();
//         data = data.concat(dataA);
//       }
//     }else{
//       // Notifications UTILISATEUR
//       const responseB = await fetch(process.env.REACT_APP_HOTE + `/liste-notifications-utilisateur/${user_id}/`);
//       if (responseB.ok) {
//         const dataB = await responseB.json();
//         console.log(dataB)
//         data = data.concat(dataB);
//       }
//     }

//     // Vérifie si l'utilisateur est UNIQUEMENT un utilisateur (et pas admin)
//     // if (accesGroupe.includes('eligibilite') || accesGroupe.includes('ExamenBlanc')) {
//     // }

//     setNotifications(data);
//   } catch (error) {
//     console.error("Erreur lors de la récupération des notifications :", error);
//   }
// }, [accesGroupe, user_id]);

const fetchNotifications = useCallback(async () => {
  try {
    let data = [];

    const adminPromise = accesGroupe.includes('Administration')
      ? fetch(process.env.REACT_APP_HOTE + `/liste-notifications-admin/`).then(res => res.ok ? res.json() : [])
      : Promise.resolve([]);

    const userPromise = fetch(process.env.REACT_APP_HOTE + `/liste-notifications-utilisateur/${user_id}/`)
      .then(res => res.ok ? res.json() : []);

    const [adminData, userData] = await Promise.all([adminPromise, userPromise]);

    // Fusionner les notifications Admin et Utilisateur
    data = [...adminData, ...userData];

    // Trier les notifications par date (du plus récent au plus ancien)
    data.sort((a, b) => new Date(b.date_action) - new Date(a.date_action));

    setNotifications(data);
  } catch (error) {
    console.error("Erreur lors de la récupération des notifications :", error);
  }
}, [accesGroupe, user_id]);



  useEffect(() => {
    fetchUserData();
    verifGroupe();
    fetchFormulaireId();
    fetchNotifications();
  }, [verifGroupe, fetchUserData, fetchFormulaireId, fetchNotifications]);

  //Fonction pour formater la date
  const getFormattedDate = (dateString) => {
    const date = moment(dateString);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');
  
    const formattedTime = format(parseISO(dateString), 'HH:mm', { locale: fr }); // Format de l'heure
  
    if (date.isSame(today, 'day')) {
      return `Aujourd'hui à ${formattedTime}`;
    } else if (date.isSame(yesterday, 'day')) {
      return `Hier à ${formattedTime}`;
    } else {
      return format(parseISO(dateString), 'dd MMMM yyyy à HH:mm', { locale: fr });
    }
  };



  

  const handleSupprimerNotif = async (notification_id) => {
    try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-notification-cloche/${notification_id}/`, {
            method: 'DELETE',
        });

        if (response.ok) {
            fetchNotifications();
            console.log("Notif supprimé avec succès !");
        } else {
            console.error('Erreur lors de la suppression de la notification de la cloche.');
        }
    } catch (error) {
        console.error('Erreur réseau:', error);
    }
};
  // Fonction de gestion du clic sur une notification
  const handleNotificationClick = (notification) => {
    if (notification.produit_concerne.includes('Eligibilité') || notification.produit_concerne.includes('Eligibilite') || notification.produit_concerne.includes('eligibilite') || notification.produit_concerne.includes('None')) {
      // Vérification des droits d'accès à AdminEligibilite
      if (accesGroupe.includes('AdminEligibilite')) {
        if (notification.action === 'soumis' || notification.action === 'modifie') {
          localStorage.setItem('notification_id', notification.id);
          localStorage.setItem('utilisateur_id', notification.utilisateur.id);
          navigate('/Eligibilite-admin');
        } 
      } 
      if (accesGroupe.includes('eligibilite')){
        // Redirection vers Eligibilite
        if (notification.action === 'commente' || notification.action === 'valide' || notification.action === 'a revoir') {
          localStorage.setItem('notification_id', notification.id);
          localStorage.setItem('utilisateur_id', notification.utilisateur.id);
          navigate('/eligibilite');
        }
      }
      fetchNotifications();
    }
    if(notification.produit_concerne.includes('Examen blanc')){
      if(accesGroupe.includes('AdminExamenBlanc')){
        if(notification.action === 'examen ajoute' || notification.action === 'examen modifie'){
          localStorage.setItem('produit_id', notification.object_id);
          localStorage.setItem('utilisateur_id', notification.utilisateur.id);
          navigate('/Gestion-des-examens');
        }
      }  
      if(accesGroupe.includes('ExamenBlanc')){
        if(notification.action === 'examen approuve' || notification.action === 'examen rejete'){
          localStorage.setItem('produit_id', notification.object_id);
          localStorage.setItem('utilisateur_id', notification.utilisateur.id);
          navigate('/Historique-examen');
        }
      }
      fetchNotifications();
    }
    handleSupprimerNotif(notification.id);
  };

  
  useEffect(() => {
    if (user_id) {
      fetchNotifications();
    }
  }, [user_id]);

  const styles = {
    dropdownMenu: {
      maxHeight: '300px',
      overflowY: 'auto',
      width: '300px',
      marginRight: '100px'
    },
    notificationItem: {
      borderBottom: '1px solid #ddd',
    },
    notificationMessage: {
      display: 'block',
      fontSize: '14px',
      color: '#333',
    },
    notificationDate: {
      fontSize: '12px',
      color: '#888',
    },
    emptyNotification: {
      textAlign: 'center',
      padding: '10px',
    },
  };
  // console.log('notif final:', notifications)
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />  // Afficher le loader pendant la déconnexion
      ) : (
        <div className="row border-bottom">
          <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: 0 }}>
            <div className="navbar-header">
              <button
                className="m-3 btn btn-success"
                onClick={() => {
                  document.body.classList.toggle('mini-navbar');
                  if (window.SmoothlyMenu) {
                    window.SmoothlyMenu(); // Appeler SmoothlyMenu après le toggle
                  } else {
                    console.error('SmoothlyMenu is not defined on window');
                  }
                }}
              >
                <i className="fa fa-bars"></i>
              </button>
            </div>
            <ul className="nav navbar-top-links navbar-right">
              {/* Cloche de notifications */}
              <li className="mr-2 d-flex">
                <a className="dropdown-toggle position-relative" data-toggle="dropdown" href="#" aria-expanded="false">
                  <i className="fa fa-bell" style={{ fontSize: '20px' }}></i>
  
                  
                  <span
                      className="badge badge-success position-absolute start-100 translate-middle"
                      style={{ right: '10px', bottom: '38px' }}
                    >
                      {
                        notifications.length
                      }
                    </span>
                </a>
  
                <ul className="dropdown-menu dropdown-alerts" style={styles.dropdownMenu}>
                  {(() => {
                    const filteredNotifications = notifications.sort((a, b) => new Date(b.date_action) - new Date(a.date_action)); // Tri par date décroissante
  
                    if (filteredNotifications.length > 0) {
                      return filteredNotifications.map((notification, index) => {
                        if (!notification.notification_message || !notification.date_action) {
                          return null; // Si la notification est mal formée, on retourne null pour ne pas l'afficher
                        }
  
                        return (
                          <li key={index} style={styles.notificationItem} onClick={() => handleNotificationClick(notification)}>
                            <a href="#" onClick={(e) => e.preventDefault()}>
                              <span style={styles.notificationDate}>
                                {getFormattedDate(notification.date_action).toLocaleString()}
                              </span>
                              <span style={styles.notificationMessage}>
                                {notification.action === 'modifie' ? (
                                  <span style={styles.userName}>
                                    {`${notification.utilisateur.prenoms} ${notification.utilisateur.nom}`} a soumis son dossier d'éligibilité.
                                  </span>
                                ) : notification.action === 'soumis' ? (
                                  <span style={styles.userName}>
                                    {`${notification.utilisateur.prenoms} ${notification.utilisateur.nom}`} a soumis son dossier d'éligibilité.
                                  </span>
                                ) : notification.action === 'examen ajoute' ? (
                                  <span style={styles.userName}>
                                    {`${notification.utilisateur.prenoms} ${notification.utilisateur.nom}`} a fait une demande d'examen blanc.
                                  </span>
                                ) : notification.action === 'examen modifie' ? (
                                  <span style={styles.userName}>
                                    {`${notification.utilisateur.prenoms} ${notification.utilisateur.nom}`} a modifié un examen blanc.
                                  </span>
                                ) : (
                                  notification.notification_message // Affiche le message par défaut si l'action n'est pas 'modifie'
                                )}
                              </span>
                            </a>
                          </li>
                        );
                      });
                    } else {
                      return (
                        <li>
                          <div style={styles.emptyNotification}>Aucune nouvelle notification disponible</div>
                        </li>
                      );
                    }
                  })()}
                </ul>
                <li>
                  <span className="m-r-sm text-muted">
                    Bienvenue, {Username}
                  </span>
                </li>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );  
};

export default Navbar;
